import React from 'react';

// Components
import ForgotPasswordFormContainer from '../../../User/ForgotPasswordForm/forgot-password-form.container';
import SingleFormLayout from '../../_layout/SingleFormLayout/single-form.layout';
import { ParentLoginNotice } from '../../../User/ParentLoginNotice/parent-login-notice.component';
import { SignedInRedirect } from '../../../_core/SignedInRedirect/signed-in-redirect.component';
import { SessionType } from '../../../../lib/types/session.types';

export const ForgotPasswordPage = () => (
  <SignedInRedirect tree={SessionType.STAFF}>
    <SingleFormLayout maxWidth="600px">
      <ForgotPasswordFormContainer />
      <ParentLoginNotice />
    </SingleFormLayout>
  </SignedInRedirect>
);
